(function () {
  'use strict';

  // Display the same total as Pumper. Pumper/Shopify remain responsible for
  // variant selection, free items, cart contents and checkout discounts.
  function parseMoney(text) {
    const value = String(text || '').replace(/[^\d.,]/g, '');
    if (!value) return null;
    const separator = Math.max(value.lastIndexOf('.'), value.lastIndexOf(','));
    const fraction = separator < 0 ? '' : value.slice(separator + 1);
    const decimal = fraction.length === 2;
    const whole = (decimal ? value.slice(0, separator) : value).replace(/[.,]/g, '');
    const cents = Number(whole) * 100 + (decimal ? Number(fraction) : 0);
    return Number.isSafeInteger(cents) && cents >= 0 ? cents : null;
  }

  function init() {
    const root = document.querySelector('[data-product-root]');
    const form = document.querySelector('#airstride-product-form');
    if (!root || !form || root.dataset.priceSyncReady) return;
    root.dataset.priceSyncReady = 'true';
    const variants = JSON.parse(document.querySelector('[data-product-json]')?.textContent || '[]');
    const currency = new Intl.NumberFormat(document.documentElement.lang || 'tr-TR', {
      style: 'currency', currency: 'TRY', minimumFractionDigits: 0, maximumFractionDigits: 2
    });
    const format = cents => currency.format(cents / 100);
    let scheduled = false;

    function setText(node, value) {
      if (node && node.textContent !== value) node.textContent = value;
    }

    function getSelection() {
      const variantId = form.querySelector('[data-variant-id]')?.value;
      const variant = variants.find(item => String(item.id) === variantId) || variants[0];
      if (!variant) return null;
      const fallback = { price: variant.price, compare: variant.compare_at_price || 0, quantity: 1 };
      const bundle = root.querySelector('#pumper_bundle_svelte');
      const tier = bundle?.querySelector('input.pumper_pair:checked');
      const tierNumber = Number(tier?.id?.match(/^cb(\d+)$/)?.[1]);
      if (!tierNumber) return fallback;
      const price = parseMoney(bundle.querySelector('#pumper_totalAmount_' + (tierNumber - 1))?.textContent);
      if (price === null) return fallback;
      const label = bundle.querySelector('#pumper__label_' + tierNumber);
      return {
        price,
        compare: parseMoney(bundle.querySelector('#pumper_originalAmount_' + (tierNumber - 1))?.textContent) || 0,
        quantity: label?.querySelectorAll('.pumper_variant_row').length || 1
      };
    }

    function sync() {
      scheduled = false;
      const selection = getSelection();
      if (!selection) return;
      const { price, compare, quantity } = selection;
      root.dataset.purchaseTotal = String(price);
      root.dataset.purchaseQuantity = String(quantity);
      setText(root.querySelector('[data-price]'), format(price));
      setText(root.querySelector('[data-atc-price]'), format(price));
      setText(document.querySelector('[data-sticky-price]'), format(price));
      setText(root.querySelector('[data-price-context]'), quantity > 1
        ? 'Seçili paket toplamı · ' + quantity + ' çift'
        : '1 çift fiyatı');
      const compareNode = root.querySelector('[data-compare-price]');
      const discountNode = root.querySelector('[data-discount]');
      const hasDiscount = compare > price;
      if (compareNode) {
        compareNode.hidden = !hasDiscount;
        setText(compareNode, hasDiscount ? format(compare) : '');
      }
      if (discountNode) {
        discountNode.hidden = !hasDiscount;
        setText(discountNode, hasDiscount ? '-%' + Math.round((compare - price) * 100 / compare) : '');
      }
    }

    function schedule() {
      if (!scheduled) {
        scheduled = true;
        requestAnimationFrame(sync);
      }
    }

    // Price text mutations cover the app's asynchronous per-item recalculation;
    // change/click events also cover switching tiers with an unchanged price.
    new MutationObserver(schedule).observe(root, {
      subtree: true, childList: true, characterData: true,
      attributes: true, attributeFilter: ['aria-pressed', 'checked']
    });
    root.addEventListener('change', schedule);
    root.addEventListener('click', schedule);
    ['prvw-option-selected', 'tierSelectionChanged', 'globalVariantSync',
      'prvw-recalculate-prices', 'pumper:tierDomReady', 'prvw-svelte-dom-ready']
      .forEach(name => { window.addEventListener(name, schedule); document.addEventListener(name, schedule); });
    sync();
  }

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
